<div mat-dialog-title>
    <h3 class="text-lg font-medium leading-6 text-gray-900">
      Creation of an Audit Team
    </h3>
</div>
<div mat-dialog-content>
    <app-equipe-audit-create-form></app-equipe-audit-create-form>
</div>